
import CollisionHelper from './helpers/CollisionHelper';
import ItemsHelper from './helpers/ItemsHelper';
import MnAssetLoader from './helpers/MnAssetLoader';
import SndManager from './helpers/SndManager';
import InteractiveManager from './helpers/InteractiveManager';
import OldBrowserMsg from '../page/parts/OldBrowserMsg';
import SceneCont from './parts/SceneCont';
import InfoBubble from './parts/InfoBubble';
import SceneManager from './helpers/SceneManager';
import { EVENTS } from '../shared/Events';

class AnScene {
  constructor() {
    // vars
    this.inited = false;

    // helpers
    this.itemsHelper = null;
    this.assetLoader = null;
    this.iManager = null;
    this.sndManager = null;
    this.sceneManager = null;

    // pools
    this.dataPool = {};
    this.imgPool = {};
    this.daysInfoArr = [];
    this.staticInfoArr = [];

    // pixi
    this.pixi = null;

    // parts
    this.infoBubble = null;
  }

  // --------------------------------------------------------------
  // Init
  // --------------------------------------------------------------

  init() {
    // disable miltiple init
    if (this.inited) {
      return;
    }
    this.inited = true;

    // check old browsers
    if (!Modernizr.audio ||
      !Modernizr.canvas ||
      !Modernizr.video
    ) {
      this.oldBrowserState();
      return;
    }

    // signals
    this.initSignals();

    // helpers
    this.collisionHelper = new CollisionHelper();
    this.itemsHelper = new ItemsHelper();
    this.assetLoader = new MnAssetLoader();
    this.sndManager = new SndManager();
    this.sceneManager = new SceneManager();

    // load assets
    this.assetLoader.loadMainAssets();
  }

  setContent() {
    // save days data reference
    this.daysInfoArr = this.dataPool['activities-info'].days;
    this.staticInfoArr = this.dataPool['activities-info'].static;

    // init pixi
    this.initPixi();

    // main parts
    this.setMainParts();

    // mouse
    this.iManager = new InteractiveManager();

    // init resize
    this.initResize();

    // loop
    this.initLoop();

    // ready call - all set & loaded
    this.contentReady();
  }

  // --------------------------------------------------------------
  // Ready
  // --------------------------------------------------------------

  contentReady() {
    // ready call - to hide main part loader
    aPage.signals.mainCall.dispatch(EVENTS.SCENE_READY);
    // init render - to render init state
    this.loopUpdate();
  }

  // --------------------------------------------------------------
  // Old browsers
  // --------------------------------------------------------------

  oldBrowserState() {
    new OldBrowserMsg();
  }

  // --------------------------------------------------------------
  // Signals
  // --------------------------------------------------------------

  initSignals() {
    this.signals = {
      sceneCallMain: new signals.Signal(), // main part events
      itemCall: new signals.Signal(), // items interaction calls
      infoCall: new signals.Signal(), // info bubble calls
      loopCall: new signals.Signal(), // loop update signal
      pxRescall: new signals.Signal(), // main part (pixi) resize call
    };
    // lsns
    this.signals.sceneCallMain.add(this.callMainFc, this);
  }

  callMainFc(sgType) {
    switch (sgType) {
      case EVENTS.SCENE_ASSETS_LOADED:
        // assets loaded set + start content
        this.setContent();
        break;
      default:
    }
  }

  // --------------------------------------------------------------
  // Pixi
  // --------------------------------------------------------------

  initPixi() {
    const rendererOptions = {
      antialiasing: true,
      transparent: false,
      resolution: 1,
      view: $('#main-canvas')[0],
      backgroundColor: 0x4f696d,
    };
    this.pixi = new PIXI.Application(aPage.resizer.canvasW, aPage.resizer.canvasH, rendererOptions);
    aPage.features.isCanvas = this.pixi.renderer instanceof PIXI.CanvasRenderer;
  }

  // --------------------------------------------------------------
  // Parts
  // --------------------------------------------------------------

  setMainParts() {
    // layers
    this.pixi.stage.addChild(new SceneCont());
    // info
    this.infoBubble = new InfoBubble();
    this.pixi.stage.addChild(this.infoBubble);
  }

  // --------------------------------------------------------------
  // Resize
  // --------------------------------------------------------------

  initResize() {
    // init update
    this.resUp();
    // add listener - to main page resize
    aPage.signals.resCall.add(this.resUp, this);
  }

  resUp() {
    // resize main part
    this.pixi.renderer.resize(aPage.resizer.canvasW, aPage.resizer.canvasH);

    // try resize parts
    this.signals.pxRescall.dispatch();
  }

  // --------------------------------------------------------------
  // Loop
  // --------------------------------------------------------------

  initLoop() {
    this.pixi.ticker.add(() => {
      if (aPage.isActive) {
        this.loopUpdate();
      }
    });
  }

  loopUpdate() {
    // ease position
    this.iManager.easePosition();
    // update parts
    this.sceneManager.msFrame = Math.min(this.pixi.ticker.elapsedMS, 30);
    this.signals.loopCall.dispatch();
  }
}

export default AnScene;



// WEBPACK FOOTER //
// ./src/js/scene/AnScene.js